export default __webpack_public_path__ + "static/media/picine.b4463fc5.jpg";